export class DocumentFilterCriteria {
  title: string;
  availableTo: string[];
  isNew: boolean;
  tags: string[];
  watchedFiles: boolean;

  constructor(title: string, availableTo: string[], isNew: boolean, tags: string[], watchedFiles: boolean) {
    this.title = title;
    this.availableTo = availableTo;
    this.isNew = isNew;
    this.watchedFiles = watchedFiles;
    this.tags = tags;
  }

}
